// project imports
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useGetMenuMaster } from 'api/menu';
import { Box } from '@mui/material';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  return (
    <>
      <SimpleBar
        sx={{
          bgcolor: '#000', // drawer black background
          color: '#fff', // default white text
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            bgcolor: '#000',
            color: '#fff'
          }
        }}
      >
        <Navigation />
        {drawerOpen && (
          <Box sx={{ p: 2 }}>
            <NavCard />
          </Box>
        )}
      </SimpleBar>
    </>
  );
}
